import { PriceProductVm, ShoppingCartDto, QuoteDto } from "api";
import { Action } from "redux";

export enum ShoppingCartActionTypes {
  SetPriceProductVm = "shoppingCart/SetPriceProductVm",
  SetShoppingCart = "shoppingCart/SetShoppingCart",
  SetQuote = "shoppingCart/SetQuote",
  UpdateLineItem = "quote/UpdateLineItem"
}

export interface SetPriceProductVm extends Action {
  type: ShoppingCartActionTypes.SetPriceProductVm;
  priceProductVm: PriceProductVm | undefined;
}

export interface SetShoppingCart extends Action {
  type: ShoppingCartActionTypes.SetShoppingCart;
  shoppingCart: ShoppingCartDto | undefined;
}

export interface SetQuote extends Action {
  type: ShoppingCartActionTypes.SetQuote;
  quote: QuoteDto | undefined;
}

export interface UpdateLineItem extends Action {
  type: ShoppingCartActionTypes.UpdateLineItem;
  orderingCode: string;
  infoType: string;
  discountRate: number | null | undefined;
  unitQuotedPrice: number | null | undefined;
  isQuote: boolean;
}

export const shoppingCartActions = {
  setPriceProductVm: (priceProductVm: PriceProductVm | undefined): SetPriceProductVm => ({
    type: ShoppingCartActionTypes.SetPriceProductVm,
    priceProductVm
  }),
  setShoppingCart: (shoppingCart: ShoppingCartDto | undefined): SetShoppingCart => ({
    type: ShoppingCartActionTypes.SetShoppingCart,
    shoppingCart
  }),
  setQuote: (quote: QuoteDto | undefined): SetQuote => ({
    type: ShoppingCartActionTypes.SetQuote,
    quote
  }),
  updateLineItem: (
    orderingCode: string,
    infoType: string,
    discountRate: number | null | undefined,
    unitQuotedPrice: number | null | undefined,
    isQuote: boolean
  ): UpdateLineItem => ({
    type: ShoppingCartActionTypes.UpdateLineItem,
    orderingCode,
    infoType,
    discountRate,
    unitQuotedPrice,
    isQuote
  })
};

export type ShoppingCartActions = SetPriceProductVm | SetShoppingCart | SetQuote | UpdateLineItem;
